import axios from "axios";

import endPoints from "../../../../../config/endPoints";

export const getAllServices = async(deptId, reqBody) => {
  
  return await axios.post(`${endPoints.services}/${deptId}`, reqBody);  
};
